export const tr = {
    'add-keywords': 'Anahtar sözcük gruplarına ekle',
    remove: 'Sil'
};
